import React, { Component } from "react";
import Logo from "../logo.svg";

class Navbar extends Component {
    render(){
        return (
            <React.Fragment>
                <nav className="navbar-main">
                    <div className="navbar container">
                        <div className="brand">
                            <a href="./">
                                <img src={Logo} alt="Easy Bank Logo" />
                            </a>
                        </div>

                        <div className="menu">
                            <ul>
                                <li><a href="./">Home</a></li>
                                <li><a href="./">About</a></li>
                                <li><a href="./">Contact</a></li>
                                <li><a href="./">Blog</a></li>
                                <li><a href="./">Careers</a></li>
                            </ul>
                        </div>

                        <div className="invite">
                            <button type="button">Request Invite</button>
                        </div>
                    </div>
                </nav>
            </React.Fragment>
        );
    }
} 

export default Navbar;